





















































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mappingData } from "@/utils/utils";
import { getDicts } from "@/api/system/data";
import {
  addDevice,
  updateDevice,
  addSystem,
  getEquipment
} from "@/api/equipment/device";
@Component({
  props: {
    addOrEditModal: {
      default: false,
      type: Boolean
    },
    addOrEditFlag: {
      type: Boolean
    },
    list: {
      type: Object
    },
    id: {
      type: Number
    }
  }
})
export default class AddOrEdit extends Vue {
  public ruleForm = {
    resourceBillId: "",
    resourcesName: "",
    resourcesModel: "",
    measureUnit: "",
    amount: undefined,
    deviceId: "",
    systemId: "",
    remark: ""
  };
  private loading = false;
  public labelName = "";
  public form = {
    typeName: "",
    parentId: ""
  };
  public systemList = [];
  public equipmentCat = [];
  public equipmentType = [];
  public addTitle = "";
  public addSystemDialog = false;
  public rules = {
    resourcesName: [
      { required: true, message: "请输入项目名称", trigger: "blur" }
    ],
    systemId: [
      { required: true, message: "请选择系统分类", trigger: "change" }
    ],
    deviceId: [
      { required: true, message: "请选择设备分类", trigger: "change" }
    ]
  };
  public formRules = {
    typeName: [
      {
        required: true,
        message: "请输入名称"
      }
    ]
  };
  public changeDialogVisible = false;
  public comp = [];
  public defaultProps = {
    children: "children",
    label: "label"
  };
  public created() {
    this.changeDialogVisible = this.addOrEditModal;
    this.getTreeData();
    if (!this.addOrEditFlag) {
      this.ruleForm = mappingData(this.list, this.ruleForm);
      this.ruleForm.id = this.list.id;
      this.changeSystem(this.ruleForm.systemId);
      //this.changeDeviceCat(this.ruleForm.equipmentId);
    }
  }
  public getTreeData() {
    getEquipment().then(res => {
      res.data.map(item => {
        if (item.id == this.id) {
          this.systemList = item.children;
          return true;
        }
      });
      this.changeSystem(this.ruleForm.systemId);
    });
  }
  public addSystem(formName) {
    this.$refs[formName].validate(valid => {
      if (valid) {
        addSystem(this.form).then(response => {
          if (response.code === 200) {
            this.$message.success("新增成功");
            this.addSystemDialog = false;
            this.getTreeData();
          } else {
            this.$message.error(response.msg);
          }
        });
      } else {
        return false;
      }
    });
  }
  public resetAddForm(formName) {
    this.$refs[formName].resetFields();
    this.addSystemDialog = false;
  }
  /**
   * 表单验证 修改密码接口
   * params formName form表单的ref
   */

  public submitForm(formName) {
    this.$refs[formName].validate(valid => {
      if (valid) {
        this.loading = true;
        if (this.addOrEditFlag) {
          addDevice(this.ruleForm).then(response => {
            this.loading = false;
            if (response.code === 200) {
              this.$message.success("新增成功");
              this.changeDialogVisible = false;
              this.$emit("showModal", this.changeDialogVisible);
            } else {
              this.$message.error(response.msg);
            }
          });
        } else {
          updateDevice(this.ruleForm).then(response => {
            this.loading = false;
            if (response.code === 200) {
              this.$message.success("编辑成功");
              this.changeDialogVisible = false;
              this.$emit("showModal", this.changeDialogVisible);
            } else {
              this.$message.error(response.msg);
            }
          });
        }
      } else {
        return false;
      }
    });
  }
  /**
   * 还原表单验证
   * params formName form表单的ref
   */

  public resetForm(formName) {
    this.$refs[formName].resetFields();
    this.changeDialogVisible = false;
    this.$emit("showModal", 1);
  }
  public changeSystem(val) {
    this.systemList.map(item => {
      if (item.id === val) {
        this.equipmentCat = item.children;
        return true;
      }
    });
  }
  // public changeDeviceCat(val) {
  //   this.equipmentCat.map((item) => {
  //     if (item.id === val) {
  //       this.equipmentType = item.children;
  //       return;
  //     }
  //   });
  // }
  public addTypeName(flag) {
    if (flag === 0) {
      this.labelName = "系统分类";
      this.addTitle = "新增系统分类";
      this.form.parentId = this.id;
    } else if (flag === 1) {
      this.labelName = "设备分类";
      this.addTitle = "新增设备分类";
      this.form.parentId = this.ruleForm.systemId;
    }
    this.addSystemDialog = true;
  }
}
